interface CardServiceProps {
    srcImage: string;
    title: string;
    text: string;
}

export default function CardService({ srcImage, title, text }: CardServiceProps) {
    return (
        <div className="bg-[rgba(39,49,103,0.06)] rounded-[6px] lg:rounded-[10px] 2xl:rounded-xl shadow-[3px_3px_4.3px_1.5px_rgba(55,71,159,0.20)] h-full relative flex flex-col justify-between">
            <div className="flex flex-col pt-2 lg:pt-5 2xl:pt-5 px-4 lg:px-6 2xl:px-8 w-full  gap-1 2xl:gap-2">
                <h2 className="text-[#000937] text-sm uppercase lg:leading-tight lg:text-[26px] 2xl:text-3xl font-montserrat font-semibold lg:font-bold lg:h-auto mb-2 lg:mb-0 lg:text-left">{title}</h2>
                <p className="text-[#000937] text-[11px] leading-3 lg:leading-normal lg:text-[17px] 2xl:text-[20px] font-montserrat lg:font-medium">{text}</p>
            </div>
            <div className="flex justify-end w-full h-auto relative mt-3 lg:mt-0">
                <img
                    src={srcImage}
                    alt={title}
                    className="h-[80px] lg:h-[190px] 2xl:h-[200px] lg:my-0 object-contain  pr-2 lg:pr-10"
                />
            </div>
        </div>
    );
}
